<div id="loader_wrapper" *ngIf="spinner?.show">
    <span class="loader"></span>
  </div> 